import React from 'react';
import styles from '../../styles/PageLoader.module.css';

interface PageLoaderProps {
  isVisible: boolean;
  message?: string;
}

const PageLoader: React.FC<PageLoaderProps> = ({ 
  isVisible, 
  message = 'Loading...' 
}) => {
  if (!isVisible) return null;

  return (
    <>
      {/* Background Overlay */}
      <div className={styles.pageLoaderOverlay} />
      
      {/* Progress Line Below TopNav */}
      <div className={styles.progressLineContainer}>
        <div className={styles.progressLine}>
          <div className={styles.progressBar}></div>
        </div>
      </div>
    </>
  );
};

export default PageLoader;
